import { useConfirm } from 'sutra/components/confirm/use-confirm'

import { useAuthContext } from 'features/auth/auth-context'

/**
 * Returns a callback that opens the standard "Sign out" confirmation modal,
 * signing the user out on confirm. Single source of truth for the signout
 * confirmation used by the user menu and the Hubs home page.
 */
export const useSignoutConfirmation = (): (() => void) => {
  const confirm = useConfirm()
  const { signOut } = useAuthContext()

  return () => {
    void confirm({
      title: 'Sign out',
      content: 'Are you sure you want to sign out?',
      okText: 'Sign out',
      cancelText: 'Cancel',
      onOk: () => signOut(),
    })
  }
}
